import { HTTPClientInterface, HTTPRequest } from "@shared/core/HTTPClientInterface";
import { buildURL, SystemURL } from "../../services/URLCatalog";
import { QontactUser } from "@shared/models/QontactUser";
import { Logger } from "@shared/utils/Logger";
import { v4 as uuid } from "uuid";

export type AnalyticsCommonFields = {
    eventID?: string
    organizationID?: string
    userID?: string
    source?: string
    timestamp?: number
    metadata?: Record<string, unknown>
}

export type AnalyticsTrackableEvent = AnalyticsCommonFields & {
    eventType: string
    [key: string]: unknown
}

export class Analytics {
    private httpClient: HTTPClientInterface
    private user?: QontactUser
    private selectedOrganizationID?: string
    private source?: string

    constructor(httpClient: HTTPClientInterface) {
        this.httpClient = httpClient
    }

    setUser(user: QontactUser) {
        this.user = user
    }

    setSelectedOrganizationID(organizationID: string) {
        this.selectedOrganizationID = organizationID
    }

    setSource(source: string) {
        this.source = source
    }

    async track<T extends AnalyticsTrackableEvent>(event: T): Promise<void> {
        const appEvent = {
            ...event,
            eventID: event.eventID ?? uuid(),
            timestamp: event.timestamp ?? Date.now(),
            organizationID: event.organizationID ?? this.selectedOrganizationID ?? "",
            userID: event.userID ?? this.user?.id,
            source: event.source ?? this.source ?? "",
        }

        const request = new HTTPRequest();
        request.url = buildURL(SystemURL.Analytics.postEvent, {})
        request.method = "POST";
        request.body = appEvent;
        Logger.log("Analytics", "tracked " + event.eventType)
        try {
            await this.httpClient.execute(request);
        } catch (error) {
            Logger.logError("Analytics", error)
        }
    }
}
